//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "module-list",
  data(){
    return{
      wrapperHeight:0,
      allLoaded:false,
      config:{
        title:'模具管理',
        url:'api/mould-dt/page',
        property: "createdDate",
        inputCondition:{
          placeholder:'模具编号/名称',
          searchCondition:'key',
          rules:[{field:"mould.name-mould.code", option: "LIKE_ANYWHERE"}]
        }
      },
      list:[]
    }
  },
  methods:{
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.list = this.list.concat(e);
        }else{
          this.list = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    init: function() {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop(){
      this.$refs.header.getlist(true);
    },
    loadBottom(){
      this.$refs.header.getMore();
    },
    viewDetail(item){
      if(item.mouldId){
        this.$router.push(`/module-detail/${item.mouldId}`);
      }
    }
  },
  mounted(){
    this.init();
    this.$refs.header.getlist();
  }
}



// WEBPACK FOOTER //
// ./src/page/procu-syner/module-list.vue